import * as yup from "yup";

export const AddProviderSchema = yup.object({
  npi: yup
    .string()
    .required(`Npi is required`)
     .test("containAllDigits", "NPI should only contain digits", (val) => val ? (/^\d+$/.test(val)) : false)
    .min(10, `Npi Invalid`)
    .max(10, `Npi Invalid`),
  ref_taxonomy_id: yup
      .string()
      .required(`Taxonomy is required`),
  firstname: yup
    .string()
    .required(`First name is required`),
  lastname: yup
    .string()
    .required(`Last name is required`),
  dea: yup
    .string()
    .when({
      is: (val:string) => val && val.length > 0,
      then: (schema) =>
        schema
          .min(9, "DEA Invalid")
          .max(9, "DEA Invalid")
          .test('CheckForInvalidChars', 'DEA Invalid', (val) => (val ? /^[a-z0-9]+$/i.test(val) : true)),
    }),
  sln: yup
    .string(),
  ptan: yup
    .string(),
  tax_id: yup.string(),
});
